import { GeneralModel } from "./general.model";
import { Hub } from "./hub.model";

export class ListCustomerPaymentType extends GeneralModel {
}